import React from 'react';

import { CSSObject } from 'styled-components';

import { MenuItem } from '../layout';
import { Menu } from '../layout/Menu';
import { MenuProps } from '../layout/Menu/Menu';
import {
  GetItemProps,
  GetMenuProps,
  GenericItem,
  DefaultItem,
  RenderMenuItem,
} from '../types';

type SingleSelectMenuProps<TItem extends GenericItem> = MenuProps & {
  menuItems: TItem[];
  getMenuProps: GetMenuProps;
  getItemProps: GetItemProps<TItem>;
  highlightedIndex: number;
  selectedItem: TItem | null;
  renderMenuItem?: RenderMenuItem<TItem>;
};

/**
 * @deprecated Single and Multi select menus have been combined.  Use DropdownMenu instead
 */
const SingleSelectMenu = <TItem extends GenericItem>({
  menuItems,
  getItemProps,
  renderMenuItem = ({ item, ...itemProps }) => (
    <MenuItem
      text={(item as unknown as DefaultItem).label}
      subtext={(item as unknown as DefaultItem).subtext}
      {...itemProps}
    />
  ),
  selectedItem,
  highlightedIndex,
  children,
  ...props
}: SingleSelectMenuProps<TItem>) => {
  return (
    <Menu {...props}>
      {menuItems.map((item, index) => {
        const { style, ...itemProps } = getItemProps?.({ item }) || {};
        return renderMenuItem({
          key: index,
          style: style as CSSObject,
          ...itemProps,
          item,
          isHighlighted: highlightedIndex === index,
        });
      })}
      {children}
    </Menu>
  );
};

export default SingleSelectMenu;
